<div class="hardware-list">
  <icc-select-box
    [title]="selectedType?.name"
    [description]="selectedType?.description"
    [imageUrl]="selectedTypeImg"
  ></icc-select-box>

  @if (colors.length > 0) {
    <mat-card appearance="outlined" class="mat-elevation-2">
      <div>
        <p>{{ 'DOOR|Wybierz kolor:' | translate }}</p>
        <icc-list [items]="colors" itemTemplate="itemColor" [scrollable]="false" [selected]="selColor" (select)="selectColor($event)">
        </icc-list>
      </div>
    </mat-card>
  }


  @if (cylinderKeysForm) {
    <form [formGroup]="cylinderKeysForm">
      @if (selectedType?.type === 'cylinder' && maxKeyQuantity > 0) {
        <mat-card appearance="outlined" class="mat-elevation-2">
          @if (!hiddenPrice) {
            <p>{{ 'DOOR|Cena za klucz dodatkowy:' | translate}} @if (listKeyPrice && listKeyPrice !== keyPrice) {
              <s>{{ listKeyPrice | currency: currency }}</s>
            } {{ keyPrice | currency: currency }}</p>
          }
          <mat-form-field appearance="outline">
            <input type="number" matInput [placeholder]="'DOOR|Ilość kluczy dodatkowych' | translate" formControlName="key" iccNumberInput [iccNumberInputInteger]="true">
            @if (cylinderKeysForm.get('key').hasError('min')) {
              <mat-error>
                {{ 'DOOR|Wprowadzona wartość jest nieprawidłowa' | translate}}
              </mat-error>
            }
            @if (cylinderKeysForm.get('key').hasError('max')) {
              <mat-error>
                {{ 'DOOR|Maksymalna ilość kluczy:' | translate}} {{maxKeyQuantity}}
              </mat-error>
            }
            <mat-hint>{{ 'DOOR|Maksymalna liczba kluczy dostępna dla wkładki:' | translate}} {{maxKeyQuantity}} </mat-hint>
          </mat-form-field>
        </mat-card>
      }
    </form>
  }
</div>

<div class="selected-summary mat-elevation-z4">
  <img [src]="selectedTypeImg" defaultImg>
  <p>{{ selectedType?.name }} {{getColorName()}}</p>
  <button
    [disabled]="selectedType?.type === 'cylinder' && !cylinderKeysForm.valid"
    mat-raised-button (click)="save()" color="primary"
    >
    {{ 'INTERFACE|Wybierz' | translate}}
  </button>
</div>
